import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    withoutHover: {
      height: 20,
      '&:hover': {
        background: 'transparent',
      },
    },
    row: {
      height: 20,

      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },

    orderIcon: {
      fontSize: 20,
      marginLeft: 4,
      cursor: 'pointer',
      opacity: 0.7,
    },

    cell: {
      fontSize: 12,
      color: palette.darkGray,
      paddingTop: 0,
      paddingBottom: 0,
      '&:first-child': {
        paddingLeft: 40,
      },

      '&:last-child': {
        paddingRight: 8,
      },

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },

    numberCell: {
      textAlign: 'center',
    },

    iconSuccess: {
      color: palette.status.success,
    },
    iconBlocked: {
      color: palette.status.error,
    },

    moreButton: {
      '&:hover': {
        background: 'transparent',
      },
    },

    actionItem: {
      fontSize: 12,
      color: palette.darkGray,
    },

    pagination: {
      '& .MuiTablePagination-caption': {
        fontSize: 12,
      },

      '& .MuiTablePagination-select': {
        border: `1px solid ${palette.darkGray}`,
        textAlignLast: 'left',
        borderRadius: 5,
        fontSize: 12,
      },
    },
    moreButtonIcon: { width: 16, height: 16 },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      fontSize: 12,
    },
    centerCell: {
      fontSize: 12,
      color: palette.darkGray,
      paddingTop: 0,
      paddingBottom: 0,
      textAlign: 'center',
      '&:first-child': {
        paddingLeft: 40,
      },

      '&:last-child': {
        paddingRight: 8,
      },

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },

    center: {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
    },
  });
